import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut, Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

export default function Unauthorized() {
  const { user, isAdmin, logout } = useAuth();
  const { t, toggleLang, lang } = useLang();
  const navigate = useNavigate();

  if (!user) return <Navigate to="/login" replace />;
  if (isAdmin) return <Navigate to="/" replace />;

  const signOut = async () => { await logout(); navigate("/login", { replace: true }); };

  return (
    <div data-testid="unauthorized-page" className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-2xl border bg-card p-8 shadow-sm space-y-6 fade-up">
        <div className="flex items-start justify-between">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
            <ShieldAlert className="h-7 w-7" />
          </div>
          <button onClick={toggleLang} data-testid="unauthorized-lang-toggle"
            className="inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-semibold hover:bg-secondary">
            <Languages className="h-4 w-4" /> {lang === "en" ? "العربية" : "English"}
          </button>
        </div>
        <div className="space-y-2">
          <h1 data-testid="unauthorized-title" className="text-2xl font-bold">{t("unauthorized_title")}</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">{t("unauthorized_desc")}</p>
        </div>
        <div data-testid="unauthorized-account" className="rounded-xl bg-secondary px-4 py-3 text-sm space-y-1">
          <p><span className="text-muted-foreground">{t("email")}:</span> <span className="font-semibold">{user.email}</span></p>
          <p><span className="text-muted-foreground">{t("role")}:</span> <span data-testid="unauthorized-role" className="font-semibold capitalize">{user.role}</span></p>
        </div>
        <Button data-testid="unauthorized-signout-btn" onClick={signOut} variant="destructive" className="w-full h-11 rounded-xl text-sm font-semibold">
          <LogOut className="h-4 w-4 me-2" /> {t("logout")}
        </Button>
        <p className="text-xs text-center text-muted-foreground">{t("unauthorized_hint")}</p>
      </div>
    </div>
  );
}
